import _ from 'underscore';

export class AssetLibraryODataError extends Error {
  constructor({
    message, originError, originErrors, bulkupsertErrors,
    errorProcessor, // use processor to extend the error object with anything needed
    ...rest // additional data passed to processor
  }) {
    super(message);
    if (originError) {
      this.originError = originError;
      const { status, errors = [] } = this.originError || {};
      this.errors = errors;
      this.status = status || '';
    } else if (originErrors) {
      this.errors = originErrors;
      this.status = '';
    } else if (bulkupsertErrors) {
      this.errors = bulkupsertErrors;
      this.status = '';
    }

    const { Code, Message, Property } = _.first(this.errors) || {};
    this.errorCode = Code || 'Unknown';

    const params = { ...rest };
    if (Message) {
      params.errorMessage = Message;
    }
    if (Property) {
      params.errorProperty = Property;
    }

    if (errorProcessor) {
      const info = errorProcessor(this.errorCode, params);
      _.extendOwn(this, info);
    }
  }
}
